import { Container, Row, Col } from "react-bootstrap";
import TrackVisibility from 'react-on-screen';
import Slider from 'react-slick';
import '../css/Services.css';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import { useEffect, useState } from 'react';


export const Services = () => {
  const [isMobile, setIsMobile] = useState(false);


  const services = [
    {
      number: "01",
      title: "Influencer Marketing",

      englishDescription: "We select high-quality global creators aligned with your brand and execute tailored campaigns to enhance visibility, influence, and drive real conversions.       "
    },
    {
      number: "02",
      title: "Content Creation & Distribution",
      englishDescription: "We help creators produce high-quality, brand-aligned content based on market trends, and distribute it strategically across multiple channels to maximize impact."
    },
    {
      number: "03",
      title: "Social Media Management",
      englishDescription: "We offer professional account management, content planning, data analysis, and community engagement to grow your brand's presence and loyalty on social platforms."
    },
    {
      number: "04",
      title: "Event Marketing",
      englishDescription: "We design and manage online and offline brand events, leveraging influencer resources to boost engagement, generate buzz, and create memorable brand experiences."
    },
    {
      number: "05",
      title: "Affiliate Service",
      englishDescription: "We build efficient affiliate programs for brands, motivating creators with commission-based incentives to achieve cost-effective and scalable marketing results."
    },
  ];

  // 检测屏幕宽度
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };
    handleResize();
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  // 轮播设置
  const sliderSettings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    // draggable: true,     // 启用拖动
    // swipe: true,         // 启用滑动
    // swipeToSlide: true,  // 允许滑动部分距离切换
    // touchThreshold: 10   // 调整触摸灵敏度
    autoplay: true,
    autoplaySpeed: 2000,
    arrows: false
  };

  return (
    <section className="services" id="services">
      <Container>
        <Row>
          <Col size={12}>
            <TrackVisibility>
              {({ isVisible }) =>
              <div className={isVisible ? "animate__animated animate__fadeInDown" : ""}>
                <h2>Our services</h2>
                <p><br></br></p>
              </div>}
            </TrackVisibility>
          </Col>
        </Row>
        {isMobile ? (
          <Slider {...sliderSettings} className="mobile-slider">
            {services.map((service, index) => (
              <div key={index}>
                <div className="service-card">

                  <div className="service-number">{service.number}</div>
                  <h3>{service.title}</h3>
                  <p className="english-description">{service.englishDescription}</p>
                </div>
              </div>
            ))}
          </Slider>
        ) : (
          // 桌面布局保持不变
          <Row className="desktop-grid">
            {services.map((service, index) => (
              <Col xl={4} lg={4} md={6} key={index}>
                <div className="service-card">
                  {/* <div className="service-number">{service.number}</div> */}
                  <h3>{service.title}</h3>
                  <p className="english-description">{service.englishDescription}</p>
                </div>
              </Col>
            ))}
          </Row>
        )}
        {/* <Row>
          {services.map((service, index) => (
            <Col md={6} lg={6} xl={6} key={index}>
              <div className="service-card">
                <div className="service-number">{service.number}</div>
                <h3>{service.title}</h3>
                <p className="english-description">{service.englishDescription}</p>
              </div>
            </Col>
          ))}
        </Row> */}
      </Container>
      <div className="artistic-elements">
        <div className="color-gradient"></div>
        <div className="artistic-lines"></div>
      </div>

      <div className="section-divider"></div>
    </section>
  );
}